import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShows = props => /*#__PURE__*/_jsxs("svg", {
  id: "shows_svg__Ebene_1",
  x: 0,
  y: 0,
  viewBox: "0 0 24 24",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  ...props,
  children: [/*#__PURE__*/_jsx("style", {
    children: '.shows_svg__st0{fill:currentColor}'
  }), /*#__PURE__*/_jsx("g", {
    id: "shows_svg__Tabs-leftsidenavi-typo",
    transform: "translate(-27 -80)",
    children: /*#__PURE__*/_jsx("g", {
      id: "shows_svg___x2F__x2F_-TABS",
      transform: "translate(11 3)",
      children: /*#__PURE__*/_jsx("g", {
        transform: "translate(8 69)",
        id: "shows_svg__ico-shows",
        children: /*#__PURE__*/_jsxs("g", {
          id: "shows_svg__Group-3",
          transform: "translate(8 8)",
          children: [/*#__PURE__*/_jsx("path", {
            id: "shows_svg__Rectangle",
            className: "shows_svg__st0",
            d: "M4.5 3h5c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2h-5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2z"
          }), /*#__PURE__*/_jsx("path", {
            id: "shows_svg__Rectangle-Copy-20",
            className: "shows_svg__st0",
            d: "M4.5 13h5c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2h-5c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2z"
          }), /*#__PURE__*/_jsx("path", {
            id: "shows_svg__Rectangle-Copy-19",
            className: "shows_svg__st0",
            d: "M14.5 3h5c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2h-5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2z"
          }), /*#__PURE__*/_jsx("path", {
            id: "shows_svg__Rectangle-Copy-21",
            className: "shows_svg__st0",
            d: "M14.5 13h5c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2h-5c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2z"
          })]
        })
      })
    })
  })]
});
export default SvgShows;